export default "__VITE_ASSET__Bv4SWMGo__"